/* eslint-disable no-unreachable */
import { debounce } from "lodash";
import type { ChangeEventHandler, FC, InputHTMLAttributes } from "react";
import { useMemo } from "react";
import useTableSearchBox from "../../hook/use-table-search-box";
import "./tableSearchBox.scss";
import type { ITableSearchBoxProps, TableSearchBoxSelect } from "./types";

const TableSearchBox: FC<ITableSearchBoxProps> = (props) => {
  const { structure, onSubmit } = props;
  const tableSearchBox = useTableSearchBox({
    onSubmit: async (data) => {
      onSubmit({ params: data });
    },
  });

  const haveTableSearchBox = useMemo(
    () => structure.some((s) => s.searchBox),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(structure)]
  );

  if (!haveTableSearchBox) {
    return null;
  }


  return <></>

  return (
    <tr className="table-search-box">
      {structure.map((column, columnKey) => {
        if (!column.searchBox) {
          return <td key={columnKey}></td>;
        }

        let component = <></>;

        switch (column.searchBox.type) {
          case "select": {
            const onChange = column.searchBox.onChange as
              | ChangeEventHandler<HTMLSelectElement>
              | undefined;

            component = (
              <Select
                {...(column.searchBox as TableSearchBoxSelect)}
                onChange={(e) => {
                  const { name, value } = e.target;
                  tableSearchBox.onChangeValue(name, onChange?.(e) ?? value);
                }}
              />
            );
            break;
          }

          case "number": {
            const onChange = column.searchBox.onChange as
              | ChangeEventHandler<HTMLInputElement>
              | undefined;

            component = (
              <Input
                {...(column.searchBox as InputHTMLAttributes<HTMLInputElement>)}
                onChange={(e) => {
                  const { name, value } = e.target;
                  tableSearchBox.onChangeValue(name, onChange?.(e) ?? +value);
                }}
              />
            );
            break;
          }

          default: {
            const onChange = column.searchBox.onChange as
              | ChangeEventHandler<HTMLInputElement>
              | undefined;

            component = (
              <Input
                {...(column.searchBox as InputHTMLAttributes<HTMLInputElement>)}
                onChange={(e) => {
                  const { name, value } = e.target;
                  tableSearchBox.onChangeValue(name, onChange?.(e) ?? value);
                }}
              />
            );
            break;
          }
        }

        return (
          <td className={column.className || ""} style={column.style} key={columnKey}>
            <div className="input-wrapper">{component}</div>
          </td>
        );
      })}
    </tr>
  );
};

export default TableSearchBox;

const Input: FC<InputHTMLAttributes<HTMLInputElement>> = (props) => {
  const { type = "text", className = "", onChange, ...rest } = props;

  return (
    <input
      type={type}
      className={`input ${className}`}
      onChange={onChange && debounce(onChange, 800)}
      {...rest}
    />
  );
};

const Select: FC<TableSearchBoxSelect> = (props) => {
  const { className = "", select, placeholder, ...rest } = props;

  return (
    <select className={`input ${className}`} {...rest}>
      {placeholder && (
        <option value="" selected>
          {placeholder}
        </option>
      )}

      {select.loading ? (
        <option disabled value="">
          Đang tải...
        </option>
      ) : (
        <>
          {select.options.map((op, index) => {
            const key = select.getItemValue(op) ?? index;
            const label = select.getItemLabel(op);

            return (
              <option key={key} value={key}>
                {label}
              </option>
            );
          })}
        </>
      )}
    </select>
  );
};
